<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>

        <div style="margin-top: 2px">
            <el-button type="primary" size="mini" @click="saveFan" :disabled="!btn.savefan">
                {{$t('getapi[6321]')}}
            </el-button>
        </div>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="ProTransactions"
                :filter_language="['del_flag']"
                :filter_thousandth="[]"
                @handleSelectionChange="handleSelectionChange"
                :header="tableHeader"
                :option="tableOption"
                ref="singleTable"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                :cell-style="cellStyle"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="order_no" :label="$t('getapi[6308]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="so_code" :label="$t('getapi[4285]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[6309]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workproc_name" :label="$t('getapi[6310]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pos_qty" :label="$t('getapi[6311]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[149]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[6312]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[6322]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="shop_from" :label="$t('getapi[6323]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="shop_to" :label="$t('getapi[6313]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="routing_sequence_no_j" :label="$t('getapi[6314]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="workproc_name_j" :label="$t('getapi[6315]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="pos_qty_j" :label="$t('getapi[6316]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_time_j" :label="$t('getapi[6317]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_person_j" :label="$t('getapi[6318]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="del_flag" :label="$t('getapi[6319]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="del_person" :label="$t('getapi[6320]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="del_time" :label="$t('getapi[3075]')"></el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="ProTransactions" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6307]')" queryData="ProTransactions" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :title="$t('getapi[6325]')" :visible.sync="isShowSaveFan" width="30%">
            <table>
                <tr>
                    <td>
                        <span>{{$t('getapi[6308]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.order_no" :disabled="true"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[4285]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.so_code" :disabled="true"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[6323]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.shop_from" :disabled="true"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[6309]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.routing_sequence_no" type="number" autocomplete="off" title="" @mousewheel.native.prevent :disabled="true"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[6310]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.workproc_name" :disabled="true"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[6311]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent :disabled="true"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[6313]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.shop_to" :disabled="true"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[6314]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.routing_sequence_no_j" type="number" autocomplete="off" title="" @mousewheel.native.prevent :disabled="true"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[6315]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.workproc_name_j" :disabled="true"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[6316]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.pos_qty_j" type="number" autocomplete="off" title="" @mousewheel.native.prevent :disabled="true"></el-input>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span>{{$t('getapi[6324]')}}</span>
                    </td>
                    <td>
                        <el-input v-model="dataDetail.qty_j_fan" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input>
                    </td>
                </tr>
            </table>
            <span slot="footer" class="dialog-footer">
				<el-button  @click="isShowSaveFan = false" size="mini">{{$t('getapi[2054]')}}</el-button>
                <el-button type="primary" @click="confirmSaveFan" size="mini">{{$t('getapi[1146]')}}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '2_wllz',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3- Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3- Common.reduceTableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('2_wllz'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [],
                btn: {
                    savefan: false
                },
                dataDetail:{},
                isShowSaveFan: false,
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('ProTransactions', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6307]"),this.$t("getapi[20]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.total > 0) {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                } else {
                    that.$refs.SetBtn.SetButtonEnable('search,refresh');
                }
            },
            btnauthority() {
                let that = this
                that.btn.savefan = false
                if (that.selectData.length == 1) {
                    that.btn.savefan = true
                }
            },
            cellStyle({row, column, rowIndex, columnIndex}) {
                if(columnIndex==11||columnIndex==12||columnIndex==13||columnIndex==14||columnIndex==15||columnIndex==16){
                    return "background:rgb(237,190,203)"
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('2_wllz',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'ProTransactions');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pro/MDIP/GetProTransactionInOutView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    } else {
                        that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps', false);
                that.$http.urlpost('/Pro/MDIP/GetProTransactionInOutToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "ProTransactions",
                    fromname: that.$t('getapi[6307]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            handleSelectionChange(val) {
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.btnauthority()
            },
            saveFan(){
                let that = this
                that.isShowSaveFan = true
                that.dataDetail = {
                    order_no: that.selectData[0].order_no,
                    so_code: that.selectData[0].so_code,
                    routing_sequence_no: that.selectData[0].routing_sequence_no,
                    workproc_name: that.selectData[0].workproc_name,
                    qty: that.selectData[0].pos_qty,
                    routing_sequence_no_j: that.selectData[0].routing_sequence_no_j,
                    workproc_name_j: that.selectData[0].workproc_name_j,
                    pos_qty_j: that.selectData[0].pos_qty_j,
                    qty_j_fan: that.selectData[0].pos_qty_j,
                    shop_from: that.selectData[0].shop_from,
                    shop_to: that.selectData[0].shop_to,
                    LangType:that.$processdata.getLang()
                }
            },
            // 签收确认
            confirmSaveFan() {
                let that = this
                let parm = that.dataDetail
                that.$http.urlpost('/Pro/MDIP/ProTransactionInSaveFan', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.isShowSaveFan = false
                        that.getView()
                    }
                });
            },

        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
</style>
